/**
 * Чистые хелперы «песни в стиле референса» (без axios — их гоняет `npm test`).
 * API-вызовы — в `@/shared/api/styleReference`.
 */
/** Расширения/типы для `accept` file-инпута. */
export const STYLE_REFERENCE_ACCEPT = "audio/*,video/*,.mp3,.wav,.m4a,.ogg,.oga,.opus,.webm,.aac,.flac,.mp4,.mov,.mkv";
const ALLOWED_EXTENSIONS = new Set([
    "mp3", "wav", "m4a", "ogg", "oga", "opus", "webm", "aac", "flac",
    "mp4", "mov", "mkv",
]);
/**
 * Похоже ли на поддерживаемый файл. Мягкая проверка: `audio/*` / `video/*` или
 * знакомое расширение (WebView миниапов часто отдаёт пустой type). Точная
 * проверка формата — на бэке.
 */
export const isSupportedStyleReferenceFile = (file) => {
    if (file.type.startsWith("audio/") || file.type.startsWith("video/")) {
        return true;
    }
    const ext = file.name.includes(".")
        ? file.name.split(".").pop().toLowerCase()
        : "";
    return ALLOWED_EXTENSIONS.has(ext);
};
/** Ответ /generate-music: референс протух (TTL 24 ч) или чужой → 404. */
export const isStyleReferenceNotFoundError = (error) => {
    const err = error;
    const detail = err?.response?.data?.detail;
    return (err?.response?.status === 404 &&
        typeof detail === "string" &&
        detail.toLowerCase().includes("style reference"));
};
/** Ошибка загрузки/анализа референса → текст для человека. */
export const styleReferenceErrorMessage = (error, language, maxSizeMb) => {
    const ru = language === "ru";
    const err = error;
    const detail = err?.response?.data?.detail;
    switch (err?.response?.status) {
        case 413:
            return ru
                ? `Файл слишком большой — до ${maxSizeMb} МБ. Обрежьте видео или выберите аудио.`
                : `The file is too large — up to ${maxSizeMb} MB. Trim the video or pick an audio file.`;
        case 400:
            return ru
                ? "Не удалось прочитать файл. Подойдут аудио (mp3, wav, m4a, ogg) или видео (mp4, mov)."
                : "Couldn't read the file. Use audio (mp3, wav, m4a, ogg) or video (mp4, mov).";
        case 422:
            return ru
                ? "В файле не нашлось музыки. Попробуйте другой трек."
                : "No music found in the file. Try another track.";
        case 429:
            // Русский detail бэка уже человеческий (rate-limit / гостевая квота).
            return ru && typeof detail === "string" && detail
                ? detail
                : ru
                    ? "Слишком много попыток. Попробуйте позже."
                    : "Too many attempts. Please try again later.";
        case 503:
            return ru
                ? "Анализ референса сейчас недоступен. Опишите стиль словами."
                : "Reference analysis is unavailable right now. Describe the style in words.";
        default:
            return ru
                ? "Не удалось разобрать стиль референса. Попробуйте ещё раз."
                : "Couldn't analyze the reference style. Please try again.";
    }
};
